import { render, staticRenderFns } from "./publicPage.vue?vue&type=template&id=6f2d050b&scoped=true&"
import script from "./publicPage.vue?vue&type=script&lang=js&"
export * from "./publicPage.vue?vue&type=script&lang=js&"
import style0 from "./publicPage.vue?vue&type=style&index=0&id=6f2d050b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d050b",
  null
  
)

export default component.exports